import { useState, useCallback } from 'react';

function generateCaptcha() {
    const a = Math.floor(Math.random() * 9) + 1;
    const b = Math.floor(Math.random() * 9) + 1;
    return { a, b, answer: a + b };
}

/**
 * useBotProtection — forma uchun bot himoyasi hook
 *
 * Ishlatilishi:
 *   const bot = useBotProtection();
 *
 *   // Modal ochilganda yoki forma mount bo'lganda:
 *   bot.reset();
 *
 *   // handleSubmit ichida, API chaqiruvdan oldin:
 *   if (!bot.validate()) return;
 *
 *   // JSX da, submit tugmadan oldin:
 *   <BotProtectionFields bot={bot} />
 */
export function useBotProtection() {
    const [honeypot, setHoneypot] = useState('');
    const [captcha, setCaptcha] = useState(generateCaptcha);
    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaError, setCaptchaError] = useState('');
    const [openTime, setOpenTime] = useState(null);

    // Modal ochilganda yoki forma ko'ringanda chaqiriladi
    const reset = useCallback(() => {
        setHoneypot('');
        setCaptcha(generateCaptcha());
        setCaptchaInput('');
        setCaptchaError('');
        setOpenTime(Date.now());
    }, []);

    // handleSubmit ichida chaqiriladi — true = o'tdi, false = bot
    const validate = useCallback(() => {
        // 1. Honeypot — bot to'ldirsa, jim rad etamiz
        if (honeypot) {
            console.warn('[BotProtection] Honeypot triggered');
            return false;
        }

        // 2. Vaqt tekshiruvi — 2 soniyadan tez yuborilsa, bot
        if (!openTime || Date.now() - openTime < 2000) {
            console.warn('[BotProtection] Submitted too fast');
            return false;
        }

        // 3. CAPTCHA
        if (parseInt(captchaInput) !== captcha.answer) {
            setCaptchaError("Noto'g'ri javob. Qayta urinib ko'ring.");
            setCaptcha(generateCaptcha());
            setCaptchaInput('');
            return false;
        }

        return true;
    }, [honeypot, openTime, captchaInput, captcha.answer]);

    return {
        honeypot, setHoneypot,
        captcha,
        captchaInput, setCaptchaInput,
        captchaError, setCaptchaError,
        reset,
        validate,
    };
}

/**
 * BotProtectionFields — formaga qo'shiladigan UI komponent
 * (Honeypot yashirin, CAPTCHA ko'rinadigan)
 */
export function BotProtectionFields({ bot }) {
    return (
        <>
            {/* Honeypot: foydalanuvchilar ko'rmaydi, botlar to'ldiradi */}
            <div
                style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, overflow: 'hidden' }}
                aria-hidden="true"
            >
                <input
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    value={bot.honeypot}
                    onChange={(e) => bot.setHoneypot(e.target.value)}
                />
            </div>

            {/* CAPTCHA */}
            <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    Tekshiruv: {bot.captcha.a} + {bot.captcha.b} = ?
                </label>
                <input
                    type="number"
                    value={bot.captchaInput}
                    onChange={(e) => {
                        bot.setCaptchaInput(e.target.value);
                        bot.setCaptchaError('');
                    }}
                    placeholder="Javobni kiriting"
                    className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm ${
                        bot.captchaError ? 'border-red-400' : 'border-gray-300'
                    }`}
                />
                {bot.captchaError && (
                    <p className="text-red-500 text-xs mt-1">{bot.captchaError}</p>
                )}
            </div>
        </>
    );
}